module.exports = __webpack_public_path__ + "static/media/mew-RINKEBY.da561fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/ethereum/mew-RINKEBY.png
// module id = 1914
// module chunks = 146